
export const CArtes = [
    {
        "imagen" : "../assets/imgs/CAH/img0.png",
        "url" : "https://www.facebook.com/share/15eLnuD9D4/?mibextid=wwXIfr",
        "titulo" : "Conoce el Centro de las Artes de Hidalgo",
        "fecha" : ""
    },
     {
        "imagen" : "../assets/imgs/CAH/img1.jpg",
        "url" : "https://www.facebook.com/share/15eLnuD9D4/?mibextid=wwXIfr",
        "titulo" : "Conoce el Centro de las Artes de Hidalgo",
        "fecha" : ""
    },
     {
        "imagen" : "../assets/imgs/CAH/img2.jpg",
        "url" : "https://www.facebook.com/share/15eLnuD9D4/?mibextid=wwXIfr",
        "titulo" : "Conoce el Centro de las Artes de Hidalgo",
        "fecha" : ""
    },
     {
        "imagen" : "../assets/imgs/CAH/img3.jpg",
        "url" : "https://www.facebook.com/share/15eLnuD9D4/?mibextid=wwXIfr",
        "titulo" : "Conoce el Centro de las Artes de Hidalgo",
        "fecha" : ""
    },
    
    
]